import { Organization } from "@/types/Organization"
import { Condition } from "../types/LabReport"
import { Patient } from "../types/Patient"
import { User } from "../types/User"

export interface RenderingContext {
  patient: Patient
  user?: User
  conditions?: Condition[]
  org?: Organization
}

// Implements basic Liquid rendering using regex. Will try to replace any variables found in `{{ }}` with
// the corresponding value from the rendering context.
//
// For example, `{{ patient.name }}` will be replaced with the patient's name.
// Or you can reference metadata like `{{ patient.metadata.key }}`.
export const renderEmail = (body: string, ctx: RenderingContext) => {
  const conditionsText = (ctx.conditions || [])
    .map(conditionText)
    .filter((txt) => txt.trim() !== "")
    .join("\n\n")

  return body.replace(/{{\s*([\w.]+)\s*}}/g, (_, key) => {
    if (key === "conditions") {
      return conditionsText
    }
    const keys = key.split(".")
    let value: any = ctx
    for (const k of keys) {
      value = value?.[k]
      if (value === undefined) break
    }
    return value !== undefined ? String(value) : ""
  })
}

const conditionText = (condition: Condition) => {
  return condition.message
}
